<template>
	<div class="OrderDetailsCard">
		<h2 class="card-title">{{ $t('text.orderDetails') }}</h2>
		<v-alert v-if="failureMessage" type="error" variant="tonal" class="mb-4" data-cy="failureBanner">
			{{ failureMessage }}
		</v-alert>
		<div class="section">
			<div class="section-title">{{ $t('text.dateAndTime') }}</div>
			<div class="section-hint">{{ $t('text.changeBookingsHint') }}</div>
			<OrderItemsTable
				:rows="rows"
				:customer="customer"
				:min-date="minDate"
				@toggle="$emit('toggle', $event)"
				@undo="$emit('undo', $event)"
				@update:draft="(row, patch) => $emit('update:draft', row, patch)"
				@update:month="(row, range) => $emit('update:month', row, range)"
			/>
			<v-checkbox
				:model-value="notifyServiceProviders"
				:label="$t('text.informServiceProviders')"
				color="blue" hide-details density="compact"
				class="mt-4"
				data-cy="notifyCheckbox"
				@update:model-value="$emit('update:notifyServiceProviders', $event)"
			/>
		</div>
	</div>
</template>

<script>
import OrderItemsTable from './OrderItemsTable.vue'

export default {
	name: 'OrderDetailsCard',
	components: { OrderItemsTable },
	props: {
		rows: Array,
		customer: Object,
		minDate: String,
		notifyServiceProviders: Boolean,
		failureMessage: String,
	},
}
</script>

<style scoped>
.OrderDetailsCard {
	background: white;
	border-radius: 8px;
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
	padding: 24px 32px;
}
.card-title { font-size: 20px; font-weight: 600; margin-bottom: 16px; }
.section-title { font-size: 15px; font-weight: 600; }
.section-hint { font-size: 12px; color: #8f8f8f; margin-bottom: 12px; }
</style>
